// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"535":"login","952":"manage-cameras"}[chunkId] + "." + {"535":"e49e1581","952":"0f868873"}[chunkId] + ".css";
};